enum Mutations {
  SET_UPCOMING_BOOKINGS = 'setUpcomingBookings',
  SET_PAST_BOOKINGS = 'setPastBookings',
  SET_NO_UPCOMING_BOOKINGS = 'setNoUpcomingBookings',
  SET_NO_PAST_BOOKINGS = 'setNoPastBookings',
}

export default Mutations
